<template>
  <div class="px-4">
    <section class="max-w-6.5xl mx-auto px-2 py-18">
      <div class="bg-sand-100 p-7 sm:px-[120px] sm:py-[56px] rounded-[10px]">
        <div class="flex flex-col items-center">
          <h2 class="h2 font-alt text-gray-900">
            {{ title }}
          </h2>
          <div class="mt-4">
            <img src="/images/top-underline.svg" alt="underline" />
          </div>

          <dl class="flex flex-col lg:flex-row justify-between w-full text-center mt-10">
            <div v-for="{ id, result, subtitle } in items" :key="id" class="flex flex-col lg:w-[210px] lg:shrink mb-10 lg:mb-0">
              <dt class="h2 text-gray-900 font-alt">{{ result }}</dt>
              <dd class="text-gray-600 lg:mt-2">{{ subtitle }}</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from "vue";
import { LongWayItemsType } from "~/types/long-way-types";

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  items: {
    type: Array as PropType<LongWayItemsType>,
    default: () => [],
  }
});
</script>

<style>

</style>
